export default __webpack_public_path__ + "static/media/security-manager.abbb4ea9.png";